var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("ExcelConfig.Title"),
        visible: _vm.dialogVisible,
        width: "600px",
        "before-close": _vm.hide,
        "destroy-on-close": "",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-position": "left",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("fileSearch.table.FileType"),
                prop: "fileType",
              },
            },
            [
              _c("BjSelectLov", {
                attrs: {
                  "option-list": _vm.fileTypeList,
                  placeholder: _vm.$t("fileSearch.table.FileType"),
                },
                model: {
                  value: _vm.form.fileType,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "fileType", $$v)
                  },
                  expression: "form.fileType",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.remarkText"), prop: "remarks" } },
            [
              _c("BjInput", {
                attrs: {
                  type: "textarea",
                  "show-word-limit": "",
                  maxlength: _vm.MAX_LENGTH.BILLMAX,
                  autosize: "",
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.remarks,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remarks", $$v)
                  },
                  expression: "form.remarks",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("ExcelConfig.Title") } },
            [
              _c(
                "UploadFile",
                {
                  ref: "UploadFileRef",
                  staticClass: "avatar-uploader",
                  attrs: {
                    limit: 1,
                    "limit-size": 5 * 1024,
                    multiple: "",
                    "show-file-list": "",
                    accept: "image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx",
                    "accept-list": [
                      "image/jpeg",
                      "image/png",
                      ".csv",
                      ".pdf",
                      ".doc",
                      ".xlsx",
                    ],
                    "auto-upload": "",
                    "limit-hide": "",
                  },
                  on: { handleFileListChange: _vm.fileListChange },
                },
                [
                  _c(
                    "template",
                    { slot: "default" },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessImportHistory.page.SelectFile")
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("cancelText")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v(_vm._s(_vm.$t("ExcelConfig.Confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }